export enum ConformityType {
	Compliant = "1",
	NotCompliant = "2",
	NotApplicable = "3",
}

export const ConformityTypeMessages = {
	[ConformityType.Compliant]: "Conforme",
	[ConformityType.NotCompliant]: "Não conforme",
	[ConformityType.NotApplicable]: "Não se aplica",
};
